import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class IsWalletAvailableWSSerializer {
    readonly KEY_VISIBLE_WALLET_ON_APP = "visible_wallet_on_app";

    deserialize(data: any): boolean {
        return data[this.KEY_VISIBLE_WALLET_ON_APP];
    }
}